import React from 'react';

function QualityControlReceiving() {
    return (
        <div>
            This page is deprecated, plase navigate to the Inbound Receiving page to view Quality Control Receiving
            information
        </div>
    );
}

export { QualityControlReceiving };
